(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbd-contact-page"] && !Shopify.designMode) return;
  try {
    
  const customizationForm = document.querySelector('.sbd-contact');
  const customizationParams = new URLSearchParams(window.location.search);
  const customizationProduct = customizationParams.get('product');
  const customizationTitle = customizationParams.get('customize');
  if (customizationForm && customizationProduct && /^[a-z0-9-]+$/.test(customizationProduct) && customizationTitle) {
    customizationForm.querySelector('#sbd-contact-title').textContent = customizationForm.dataset.customizeTitle;
    customizationForm.querySelector('.sbd-contact__lede').textContent = customizationForm.dataset.customizeIntro.replace('__PRODUCT__', customizationTitle.slice(0, 255));
    const message = customizationForm.querySelector('#SbdContactBody');
    const topic = customizationForm.querySelector('#SbdContactTopic');
    if (message && !message.value.trim()) {
      const intro = customizationForm.dataset.customizeMessage.replace('__PRODUCT__', customizationTitle.slice(0, 255));
      const productUrl = new URL(customizationForm.dataset.productsPath + customizationProduct, window.location.origin);
      message.value = intro + '\n' + productUrl.href + '\n\n' + customizationForm.dataset.customizeChanges + '\n';
      if (topic) topic.value = 'Customization question';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
